import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import { useSelector } from 'react-redux';
import setUiMessage from '../../../Utilities/Tostify';
import useFormValidation from '../../../hooks/zodFormValidation';
import appSchema from '../../../schema/appSchema';
import { getMaskPhone, getMaskZip } from '../../../Utilities/Utilities';

function AddEditReferralProviderPopup({
  onClose,
  onReload,
  editPopup,
  setEditPopup,
}) {
  const { user } = useSelector((store) => store.auth);

  const [data, setData] = useState('');
  const [formData, setFormData] = useState({
    id: '',
    doctor_first_name: '',
    doctor_last_name: '',
    qualification: '',
    clinic_name: '',
    speciality: '',
    npi_no: '',
    address_1: '',
    city: '',
    state: '',
    zip: '',
    email: '',
    phone_l: '',
    phone_m: '',
    fax: '',
    description: '',
  });
  const [isSubmit, setSubmit] = useState(false);

  const { errors, validateForm } = useFormValidation({
    schema: appSchema.referralProviderSchema(),
    formData: formData,
    isSubmit,
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/commonTask/openAddEditRefMasterPopup',
          {
            refProviderId: editPopup?.referringMasterId,
            popUpType: 'refProvider',
          },
        );
        if (response.status === 200) {
          setData(response.data);
          setFormData({
            id: response.data.refProviderMaster[0]?.id || '',
            doctor_first_name:
              response.data.refProviderMaster[0]?.doctor_first_name || '',
            doctor_last_name:
              response.data.refProviderMaster[0]?.doctor_last_name || '',
            qualification:
              response.data.refProviderMaster[0]?.qualification || '',
            clinic_name: response.data.refProviderMaster[0]?.clinic_name || '',
            speciality: response.data.refProviderMaster[0]?.speciality_id || '',
            npi_no: response.data.refProviderMaster[0]?.npi_no || '',
            address_1: response.data.refProviderMaster[0]?.address_1 || '',
            city: response.data.refProviderMaster[0]?.city || '',
            state: response.data.refProviderMaster[0]?.state || '',
            zip: getMaskZip(response.data.refProviderMaster[0]?.zip || ''),
            email: response.data.refProviderMaster[0]?.email || '',
            phone_l: getMaskPhone(
              response.data.refProviderMaster[0]?.phone_l || '',
            ),
            phone_m: getMaskPhone(
              response.data.refProviderMaster[0]?.phone_m || '',
            ),
            fax: getMaskPhone(response.data.refProviderMaster[0]?.fax || ''),
            description: response.data.refProviderMaster[0]?.description || '',
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [editPopup]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone_l' || name === 'phone_m' || name === 'fax') {
      setFormData({ ...formData, [name]: getMaskPhone(value) });
    } else if (name === 'zip') {
      setFormData({ ...formData, [name]: getMaskZip(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const onSaveUpdate = async () => {
    setSubmit(true);
    const validationError = validateForm();
    if (validationError) return;

    try {
      const response = await post('api/commonTask/saveUpdateRefMaster', {
        userId: user?.id,
        refProviderId: editPopup?.referringMasterId || '',
        ...formData,
      });
      if (response.status === 200) {
        setUiMessage('suc', 'Successfully added New Provider/Clinic.');
        onReload();
        onClose();
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="openReferringProviderPopup">
        {/* HEADER */}
        <div className="addressBookHeader flex justify-between items-center">
          <span className="addressTitle">
            <h2>
              {editPopup?.referringMasterId
                ? 'Update Provider/Clinic'
                : 'Add New Provider/Clinic'}
            </h2>
          </span>
          {/* <Button className="addressClose" variant="circle" onClick={onClose}>
            X
          </Button> */}
          <span
            class="close-btn close-btn text-gray-400 mt-0 cursor-pointer"
            onClick={onClose}
            style={{ fontSize: '25px' }}
          >
            &times;
          </span>
        </div>

        {/* BODY */}
        <div className="addressBody">
          <div className="scrollbar-default mt-3">
            {/* FIRST ROW */}
            <div className="addressBodyRow">
              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">First Name *</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="doctor_first_name"
                    value={formData.doctor_first_name}
                    placeholder="Provider first name"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.doctor_first_name &&
                      errors?.doctor_first_name?.message}
                  </p>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">Last Name *</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="doctor_last_name"
                    value={formData.doctor_last_name}
                    placeholder="Provider last name"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.doctor_last_name &&
                      errors?.doctor_last_name?.message}
                  </p>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">Degree/Credentials</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="qualification"
                    value={formData.qualification}
                    placeholder="MD, DO, NP etc"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* CLINIC NAME */}
            <div className="addressBodyRow">Clinic Name *</div>
            <div className="addressBodyRow">
              <input
                className="addressBookSearh h-8"
                type="text"
                name="clinic_name"
                value={formData.clinic_name}
                placeholder="Clinic or facility name"
                onChange={handleChange}
              />
              <p className="error-msg">
                {errors?.clinic_name && errors?.clinic_name?.message}
              </p>
            </div>

            {/* SPECIALTY & NPI */}
            <div className="addressBodyRow">
              <div style={{ float: 'left', width: '49%' }}>
                <div className="addressBodyRow">Specialty</div>
                <div className="addressBodyRow">
                  <select
                    id="refSpecialty"
                    name="speciality"
                    className="chzn-select addressBookSearh h-8"
                    value={formData.speciality}
                    onChange={handleChange}
                  >
                    <option value=""></option>
                    {data?.specialityMaster?.map((sp) => (
                      <option key={sp.id} value={sp.id}>
                        {sp.speciality}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '49%' }}>
                <div className="addressBodyRow">NPI Number</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="npi_no"
                    value={formData.npi_no}
                    placeholder="Provider NPI"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.npi_no && errors?.npi_no?.message}
                  </p>
                </div>
              </div>
            </div>

            {/* ADDRESS 1 */}
            <div className="addressBodyRow">Street Address</div>
            <div className="addressBodyRow">
              <input
                className="addressBookSearh h-8"
                type="text"
                name="address_1"
                value={formData.address_1}
                placeholder="Street Address"
                onChange={handleChange}
              />
              <p className="error-msg">
                {errors?.address_1 && errors?.address_1?.message}
              </p>
            </div>

            {/* CITY, STATE, ZIP */}
            <div className="addressBodyRow">
              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">City</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="city"
                    value={formData.city}
                    placeholder="City"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.city && errors?.city?.message}
                  </p>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">State</div>
                <div className="addressBodyRow">
                  <select
                    id="refState"
                    name="state"
                    className="chzn-select addressBookSearh h-8"
                    value={formData.state}
                    onChange={handleChange}
                  >
                    <option value=""></option>
                    {data?.stateMaster?.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.stateName}
                      </option>
                    ))}
                  </select>
                  <p className="error-msg">
                    {errors?.state && errors?.state?.message}
                  </p>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">ZIP Code *</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="zip"
                    value={formData.zip}
                    placeholder="12345 or 12345-6789"
                    maxLength="10"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.zip && errors?.zip?.message}
                  </p>
                </div>
              </div>
            </div>

            {/* EMAIL */}
            <div className="addressBodyRow">Email</div>
            <div className="addressBodyRow">
              <input
                className="addressBookSearh h-8"
                type="text"
                name="email"
                value={formData.email}
                placeholder="Email address"
                onChange={handleChange}
              />
              <p className="error-msg">
                {errors?.email && errors?.email?.message}
              </p>
            </div>

            {/* PHONE NUMBERS */}
            <div className="addressBodyRow">
              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">Desk Phone</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="phone_l"
                    value={formData.phone_l}
                    placeholder="(000) 000-0000"
                    maxLength="14"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.phone_l && errors?.phone_l?.message}
                  </p>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">Cell Phone</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="phone_m"
                    value={formData.phone_m}
                    placeholder="(000) 000-0000"
                    maxLength="14"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.phone_m && errors?.phone_m?.message}
                  </p>
                </div>
              </div>

              <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

              <div style={{ float: 'left', width: '32%' }}>
                <div className="addressBodyRow">Fax *</div>
                <div className="addressBodyRow">
                  <input
                    className="addressBookSearh h-8"
                    type="text"
                    name="fax"
                    value={formData.fax}
                    placeholder="(000) 000-0000"
                    maxLength="14"
                    onChange={handleChange}
                  />
                  <p className="error-msg">
                    {errors?.fax && errors?.fax?.message}
                  </p>
                </div>
              </div>
            </div>

            {/* NOTE */}
            <div className="addressBodyRow">Note</div>
            <div className="addressBodyRow">
              <textarea
                className="addressBookSearh h-8"
                name="description"
                rows="3"
                placeholder="Additional notes or special instructions"
                value={formData.description}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>
          {/* BUTTONS */}
          <div className="addressBodyRow flex gap-2 justify-end">
            {/* <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                onSaveUpdate();
              }}
            >
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </Button> */}
            <button
              className="btn-outline-lightgray text-accent-forground rounded-md"
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="btn-primary rounded-md" onClick={onSaveUpdate}>
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEditReferralProviderPopup;
